import React from 'react';
import PropTypes from 'prop-types';

const createOptions = options => {
    return options.map((option, index) => {
        return (
            <option key={index} value={option.value}>
                {option.name}
            </option>
        );
    });
};

const Select = ({
    className = '',
    handleChange,
    label,
    options,
    selectClassName = '',
    selectedValue
}) => {
    if (!options) {
        return null;
    }
    return (
        <form className={`align-items-center ${className}`}>
            {label ? (
                <label className="mb-1 mr-2" htmlFor="searchResultSort">
                    {label}
                </label>
            ) : null}
            <div className="form-group w-100 mb-0">
                <select
                    className={`form-control form-control-rounded single-select ${selectClassName}`}
                    id="searchResultSort"
                    value={selectedValue}
                    onChange={e => {
                        handleChange(e.target.value);
                    }}>
                    {createOptions(options)}
                </select>
            </div>
        </form>
    );
};

Select.propTypes = {
    className: PropTypes.string,
    handleChange: PropTypes.func,
    label: PropTypes.string,
    options: PropTypes.array,
    selectClassName: PropTypes.string,
    selectedValue: PropTypes.string
};

export default Select;
